<template>
  <div id="app">
    <div class="main-wrapper">
       <m-header @changeToEnglish="changeToEnglish" v-show="isShow" class="fixed-line"></m-header>
       <tab v-show="isShow"></tab>
       <blue-tab v-show="isShow"></blue-tab>
       <chang-title @clickIcon="alclickIcon" v-show="!isShow" class="showtitle"></chang-title>
       <top-left @change="changeToEnglish" @leftTopWhite="leftTopWhite" ref="chang" class="top-abs"></top-left>
       <router-view ref="changeToEn"></router-view>
       <bottom-adr></bottom-adr>
     </div>
  </div>
</template>

<script>
  import MHeader from 'components/m-header/m-header'
  import Tab from 'components/tab/tab'
  import blueTab from 'components/blue-tab/blue-tab'
  import bottomAdr from 'components/bottom-adr/bottom-adr'
  import changTitle from 'common/chang-title/chang-title'
  import topLeft from 'common/top-left/top-left'


  export default {
    data() {
      return {
        isShow: true,
        fullWidth: document.body.clientWidth,
        flag: true
      }
    },
    created() {
      this.fullWidth > 550 ? this.isShow = true : this.isShow = !true
      window.addEventListener('resize', this.handleResize)
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.handleResize)
    },
    methods: {
      handleResize() {
        this.fullWidth = document.body.clientWidth
      },
      moveMenu() {
        console.log('move')
      },
      changeToEnglish() {
        let changeToEn = document.getElementsByClassName('bright-main')
        this.$refs.changeToEn.changeToEn()
        console.log(this.$refs.changeToEn)
        this.alclickIcon()
      },
      alclickIcon() {
        let topLeft = this.$refs.chang
        if(this.flag) {
          topLeft.$el.style.setProperty("left", 0 )
          this.flag = !this.flag
        } else {
          topLeft.$el.style.setProperty("left", '-100%' )
          this.flag = !this.flag
        }
      },
      leftTopWhite() {
        console.log('clickicon')
        this.alclickIcon()
      }
    },
    watch: {
      fullWidth(wid) {
        wid > 550 ? this.isShow = true : this.isShow = !true
      }
    },
    components: {
      MHeader,
      Tab,
      blueTab,
      bottomAdr,
      changTitle,
      topLeft
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus">
  #app
    position: fixed
    top: 0
    width: 100%
    bottom: 0
    .main-wrapper
      height: 100%
      overflow: scroll
      overflow-x: hidden
      .fixed-line
        z-index: 100
</style>



// WEBPACK FOOTER //
// src/App.vue